<template>
  <div>
    <btn v-if="legalProfiles.length > 0" type="button" title="Запросить акт сверки" @click="toggleModal"></btn>
    <div v-else class="alert alert-info">Для запроса акта сверки нужно заполнить профиль юридического лица</div>
    <table>
      <thead>
      <tr>
        <th>Код заказа<br></th>
        <th>Стоимость<br></th>
        <th>Товары<br></th>
        <th>Действия</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="order of closeDocs">
        <td><b>{{order.ID}}</b><br></td>
        <td>{{order.PRICE}} руб.</td>
        <td class="cart-history-name">
          <template v-for="item of order.ITEMS">
            <a :key="item.ID" v-if="item.DETAIL_PAGE_URL" :href="item.DETAIL_PAGE_URL">{{item.NAME}}</a>
            <span :key="item.ID" v-else>{{item.NAME}}</span>
          </template>
        </td>
        <td>
          <a class="defect-button" title="Посмотреть счет"
             target="_blank"
             :href="'/personal/close_doc/waybill.php?ORDER_ID=' + order.ID + '&SHOW_ALL=Y'">
            Посмотреть счет
          </a>
        </td>
      </tr>
      </tbody>
    </table>
    <modal v-if="modal" @close="toggleModal">
      <template slot="header"><h2>Запросить акт сверки</h2></template>
      <template slot="body">
        <request-reconciliation @close="toggleModal"></request-reconciliation>
      </template>
      <template slot="footer"></template>
    </modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Btn from '../form/Btn'
  import RequestReconciliation from '../RequestReconciliation'
  import Modal from '../Modal'

  export default {
    name: 'close-docs',
    components: {Modal, RequestReconciliation, Btn},
    created () {
      if (this.closeDocs.length <= 0) {
        this.$store.dispatch('closeDocs/fetchCloseDocs')
      }

      if (this.legalProfiles.length <= 0) {
        this.$store.dispatch('profile/updateProfileList')
      }
    },
    computed: {
      ...mapGetters('closeDocs', [
        'closeDocs'
      ]),
      ...mapGetters('profile', [
        'legalProfiles'
      ])
    },
    data () {
      return {
        modal: false
      }
    },
    methods: {
      toggleModal () {
        this.modal = !this.modal
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Personal/CloseDocs.vue